import moment from "moment";
import { Avatar, Grid, Typography, Stack } from "@mui/material";
import EventIcon from "@mui/icons-material/Event";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import { getInitials } from "@/Common/helpers/user";

// Constants
import { DATE_FORMAT } from "@/Constants/date";

interface IBirthdayItemProps {
	name: string;
	birthDate: string;
}

export const BirthdayItem = ({ name, birthDate }: Readonly<IBirthdayItemProps>) => {
	return (
		<Grid item xs={6}>
			<Stack className="px-4 py-0 rounded-2xl bg-body h-[42px]" alignItems="center" direction="row" spacing={1}>
				<Avatar className="!font-montserrat !text-sm !font-bold !bg-transparent !text-primary !border-primary border-2 !w-[30px] !h-[30px]">
					{getInitials(name)}
				</Avatar>
				<Stack
					justifyContent="center"
					alignItems="center"
					direction="column"
					rowGap="1px"
					className="overflow-hidden w-full h-full px-0 py-2"
				>
					<Stack alignItems="center" direction="row" className="w-full !gap-[3px]">
						<AccountCircleIcon className="!text-neutral-gray !w-[11px] !h-[11px]" />
						<Typography noWrap className="!font-sans !text-sm/[1] text-[#164199] !font-[550] !w-full">
							{name}
						</Typography>
					</Stack>
					<Stack alignItems="center" className="w-full" direction="row" columnGap="3px">
						<EventIcon className="!text-neutral-gray !w-[11px] !h-[11px]" />
						<Typography className="!font-sans !text-[11px]/[1] !text-primary !font-semibold">
							{moment(birthDate).utc().format(DATE_FORMAT.monthDayOrdinal)}
						</Typography>
					</Stack>
				</Stack>
			</Stack>
		</Grid>
	);
};
